import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams,ToastController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { AuthService } from '../../providers/auth-service'
import { PushProvider } from '../../providers/push/push'
import { ClientesProvider } from '../../providers/clientes/clientes'
import { NUBE_AWS } from '../../config/url.servicio';
import { ParametrosGeneralesRedux } from '../../providers/redux/parametrosgenerales/parametrosgenerales'
/**
 * Generated class for the ParametrosGeneralesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-parametros-generales',
  templateUrl: 'parametros-generales.html',
  providers: [ AuthService,PushProvider, ParametrosGeneralesRedux ]
})
export class ParametrosGeneralesPage implements OnInit {
  CheckEscucharMesas:boolean = false
  items:valores[] = []
  notificaciones:notificaciones[] = []
  lotesenproductos:lotesenproductos[] = []
  manejaImpresoraPorDefecto:manejaImpresoraPorDefecto[] = []
  deseaImprimirEnElCierre:deseaImprimirEnElCierre[] = []

  Impresoratipobluetooth:Impresoratipobluetooth[] = []
  fechaSistema:Date
  ManejaCodigoBarra: ManejarodigoDeBarras[] = []
  ImprimeComandasV: ImprimeLasComandas[] = []
  config: any = {};
  fields: any = [];
  constructor(public navCtrl: NavController, public navParams: NavParams,public storage:Storage,
    public auth: AuthService,
    public servicioPush:PushProvider,public toastControllers:ToastController,
    public utilidades:ClientesProvider,
    public utilsRedux: ParametrosGeneralesRedux) {
    this.dataInicial()
    this.items.push({nombre:"Si", valor:"S"},{nombre:"No",valor:"N"})
    this.notificaciones.push({nombre:"Si",valor:"S"},{nombre:"No",valor:"N"})
    this.lotesenproductos.push({nombre:"Si",valor:"S"},{nombre:"No",valor:"N"})
    this.manejaImpresoraPorDefecto.push({nombre:"Si",valor:0},{nombre:"No",valor:1})
    this.Impresoratipobluetooth.push({nombre:"Si",valor:"B"},{nombre:"No",valor:""})
    this.ManejaCodigoBarra.push({nombre:"No",valor:"N"},{nombre:"Si",valor:"S"})
    this.ImprimeComandasV.push({nombre:"No",valor:"N"},{nombre:"Si",valor:"S"})
    this.deseaImprimirEnElCierre.push({nombre:"Si",valor:"S"},{nombre:"No",valor:"N"})
  }

  cambiarCheckEscucharMesas(valor:any){
    this.storage.get('imprimirmesasautomaticamente').then((val)=>{
      if(val){
        if(valor=== "S"){
          this.storage.set('imprimirmesasautomaticamente','S')
        }else{
          this.storage.set('imprimirmesasautomaticamente','N')
        }
      }else{
        this.storage.set('imprimirmesasautomaticamente',valor)
      }
    })

  }

  cambiarCheckNotificaciones(valor:any){
    this.storage.get('notificaciones').then((val)=>{
      if(val){
        if(valor=== "S"){
          this.storage.set('notificaciones','S')
        }else{
          this.storage.set('notificaciones','N')
        }
      }else{
        this.storage.set('notificaciones',valor)
      }
    })
  }

  valoresSelect(data:string){
    if(data['valor'] === "S"){
      this.cambiarCheckEscucharMesas('S')
    }else {
      this.cambiarCheckEscucharMesas('N')
    }
  }

  valoresSelectImagenes(data:string){
    if(data['valor'] === "S"){
      this.cambiarCheckEscucharMesas('S')
    }else {
      this.cambiarCheckEscucharMesas('N')
    }
  }

  valoresSelectNotificaciones(data:string){
    if(data['valor'] === "S"){
      this.cambiarCheckNotificaciones('S')
    }else {
      this.cambiarCheckNotificaciones('N')
    }
  }

  valoresSelectActualizarmanejaLotesEnProductos(data:string){
    if(data['valor'] === "S"){
      this.cambiarCheckManejaLotesEnProductos('S')
    }else {
      this.cambiarCheckManejaLotesEnProductos('N')
    }
  }

  valoresSelectManejaImpresoraPorDefecto(data:string){
    if(data['valor'] === 1){
      this.cambiarCheckManejaImpresoraPorDefecto(1)
    }else {
      this.cambiarCheckManejaImpresoraPorDefecto(0)
    }
  }

  valoresSelectImpresoratipobluetooth(data:string){
    if(data['valor'] === "B"){
      this.cambiarCheckImpresoratipobluetooth("B")
    }else {
      this.cambiarCheckImpresoratipobluetooth("")
    }
  }

  valoresImprimeComadasAutomaticamente(data:string){
    if(data['valor'] === "S"){
      this.cambiarChecImprimeComandas("S")
    }else {
      this.cambiarChecImprimeComandas("N")
    }
  }

  cambiarCheckImpresoratipobluetooth(valor:any){

    this.storage.get('companiasId').then((val)=>{
      if(val){

        this.servicioPush.buscarParametrosGenerales(val)
        .subscribe((valores)=>{
          let id = NUBE_AWS ? JSON.parse(valores['_body']).data[0][0].parametrosGeneralesId : valores[0][0].parametrosGeneralesId
          let data = {}

          data['name']= "dataDynamicCrud"
          data['parametrosGeneralesId']= id
          data['queHago']= "A"
          data['bluetooth']= valor
          data['nombreTabla']= "parametrosGenerales"

          this.servicioPush.actualizarParametrosGenerales(data)
          .subscribe((nuevoValor)=>{
            this.mensajeToast('Registro guardado con exito')
            this.gestionarParametrosGeneralesRedux()
          },(error)=>{
            console.log(error)
          })
        },(error)=>{
          console.log(error)
        })

      }
    })
  }

  async gestionarParametrosGeneralesRedux() {
    let buscarParametrosGeneralesStore: any = await this.utilsRedux.buscarParametrosGeneralesStore()
    this.utilsRedux.buscarParametrosGeneralesRedux(buscarParametrosGeneralesStore.parametrosGenerales[0].companiasId, buscarParametrosGeneralesStore.parametrosGenerales[0].usuariosId)
  }
  valoresManejaCodigoDeBarras(data:string){
    if(data['valor'] === "S"){
      this.cambiarManejaCodigoDeBarras("S")
    }else {
      this.cambiarManejaCodigoDeBarras("N")
    }
  }

  cambiarManejaCodigoDeBarras(valor:any){

    this.storage.get('companiasId').then((val)=>{
      if(val){

        this.servicioPush.buscarParametrosGenerales(val)
        .subscribe((valores)=>{

          let id = NUBE_AWS ? JSON.parse(valores['_body']).data[0][0].parametrosGeneralesId : valores[0][0].parametrosGeneralesId
          let data = {}

          data['name']= "dataDynamicCrud"
          data['parametrosGeneralesId']= id
          data['queHago']= "A"
          data['manejaCodigoDeBarras']= valor
          data['nombreTabla']= "parametrosGenerales"

          this.servicioPush.actualizarParametrosGenerales(data)
          .subscribe((nuevoValor)=>{

            this.mensajeToast('Registro guardado con exito')
          },(error)=>{
            console.log(error)
          })
        },(error)=>{
          console.log(error)
        })

      }
    })

  }


  cambiarCheckManejaImpresoraPorDefecto(valor:any){

    this.storage.get('companiasId').then((val)=>{
      if(val){

        this.servicioPush.buscarParametrosGenerales(val)
        .subscribe((valores)=>{

          let id = NUBE_AWS ? JSON.parse(valores['_body']).data[0][0].parametrosGeneralesId : valores[0][0].parametrosGeneralesId
          let data = {}

          data['name']= "dataDynamicCrud"
          data['parametrosGeneralesId']= id
          data['queHago']= "A"
          data['manejaImpresoPorDefecto']= valor
          data['nombreTabla']= "parametrosGenerales"

          this.servicioPush.actualizarParametrosGenerales(data)
          .subscribe((nuevoValor)=>{
            this.mensajeToast('Registro guardado con exito')
          },(error)=>{
            console.log(error)
          })
        },(error)=>{
          console.log(error)
        })

      }
    })
  }


  cambiarChecImprimeComandas(valor:any){

    this.storage.get('companiasId').then((val)=>{
      if(val){

        this.servicioPush.buscarParametrosGenerales(val)
        .subscribe((valores)=>{

          let id = NUBE_AWS ? JSON.parse(valores['_body']).data[0][0].parametrosGeneralesId : valores[0][0].parametrosGeneralesId
          let data = {}

          data['name']= "dataDynamicCrud"
          data['parametrosGeneralesId']= id
          data['queHago']= "A"
          data['imprimeComandas']= valor
          data['nombreTabla']= "parametrosGenerales"

          this.servicioPush.actualizarParametrosGenerales(data)
          .subscribe((nuevoValor)=>{
            this.mensajeToast('Registro guardado con exito')
          },(error)=>{
            console.log(error)
          })
        },(error)=>{
          console.log(error)
        })

      }
    })
  }



  cambiarCheckManejaLotesEnProductos(valor:any){

    this.storage.get('companiasId').then((val)=>{
      if(val){

        this.servicioPush.buscarParametrosGenerales(val)
        .subscribe((valores)=>{

          let id = NUBE_AWS ? JSON.parse(valores['_body']).data[0][0].parametrosGeneralesId : valores[0][0].parametrosGeneralesId
          let data = {}

          data['name']= "dataDynamicCrud"
          data['parametrosGeneralesId']= id
          data['queHago']= "A"
          data['manejaLotesEnProductos']= valor
          data['nombreTabla']= "parametrosGenerales"

          this.servicioPush.actualizarParametrosGenerales(data)
          .subscribe((nuevoValor)=>{

            this.mensajeToast('Registro guardado con exito')
          },(error)=>{
            console.log(error)
          })
        },(error)=>{
          console.log(error)
        })

      }
    })
  }



  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

  mensajeToast(mensaje: string) {
    let item =    {
        "duration": 1000,
        "position": "buttom"
      }
      item["message"] = mensaje;
    let toast = this.toastControllers.create(item);
    toast.present();
  }

  changeDate(){
    let fechaSistema = this.fechaSistema
    // '2018-07-28 00:00:00.000'


      if(fechaSistema!==undefined){
        var f = new Date();
        var fecha = fechaSistema
        // let fechaSinFormato = f.getFullYear() + "-" + (f.getMonth() +1) + "-" + f.getDate()

        // let fecha = this.utilidades.formatearCadena(fechaSinFormato)
        let fechaNueva = fecha + " " + f.getHours() +":" + f.getMinutes() + ":" + f.getSeconds()
        this.storage.set('fechaSistema',fechaNueva)
        this.mensajeToast('Fecha guardado con exito')
      } else{

      }
    }


    valoresSelectDeseaImprimirEnElCierre(data:string){
      if(data['valor'] === "S"){
        this.cambiarCheckDeseaImprimirEnElCierre("S")
      }else {
        this.cambiarCheckDeseaImprimirEnElCierre("N")
      }
    }

    cambiarCheckDeseaImprimirEnElCierre(valor:any){

      this.storage.get('companiasId').then((val)=>{
        if(val){

          this.servicioPush.buscarParametrosGenerales(val)
          .subscribe((valores)=>{

            let id = NUBE_AWS ? JSON.parse(valores['_body']).data[0][0].parametrosGeneralesId : valores[0][0].parametrosGeneralesId
            let data = {}

            data['name']= "dataDynamicCrud"
            data['parametrosGeneralesId']= id
            data['queHago']= "A"
            data['imprimirCierre']= valor
            data['nombreTabla']= "parametrosGenerales"

            this.servicioPush.actualizarParametrosGenerales(data)
            .subscribe((nuevoValor)=>{
              this.mensajeToast('Registro guardado con exito')
            },(error)=>{
              console.log(error)
            })
          },(error)=>{
            console.log(error)
          })

        }
      })
    }


    mapFields(data: any): any[] {
      let fields: any = [];

      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          let field = data[key];

          // Manejo de tipo de campo basado en la estructura de datos
          if (typeof field === 'number' || typeof field === 'string') {
            // Si el campo es número o cadena, conviértelo a número si es posible
            field = typeof field === 'string' ? Number(field) : field;

            fields.push({
              label: this.capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1')), // Capitaliza la primera letra
              key: key,
              type: typeof field // Puede ser 'number' o 'string'
            });
          } else if (Array.isArray(field)) {
            if (field.length > 0 && typeof field[0] === 'object') {
              // Si es una lista de objetos, probablemente un select o multipleSelect
              fields.push({
                label: this.capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1')), // Capitaliza la primera letra
                key: key,
                type: 'multipleSelect',
                options: field.map(option => {
                  // Manejo seguro de opciones para evitar errores de null/undefined
                  let optionKey = Object.keys(option)[0] || '';
                  return {
                    key: optionKey, // El nombre de la opción
                    value: option[optionKey] || '' // El valor asociado o cadena vacía si es null
                  };
                })
              });
            } else {
              fields.push({
                label: this.capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1')), // Capitaliza la primera letra
                key: key,
                type: 'list',
                options: field // Asegúrate de que field sea un array válido
              });
            }
          } else if (typeof field === 'object') {
            // Si el campo es un objeto
            let type = field.multipleSelect === 'S' ? 'multipleSelect' : 'select';

            fields.push({
              label: this.capitalizeFirstLetter(key.replace(/([A-Z])/g, ' $1')), // Capitaliza la primera letra
              key: key,
              type: type,
              options: (field.opciones || []).map(option => {
                // Manejo seguro de opciones para evitar errores de null/undefined
                let optionKey = Object.keys(option)[0] || '';
                return {
                  key: optionKey, // El nombre de la opción
                  value: option[optionKey] || '' // El valor asociado o cadena vacía si es null
                };
              }),
              seleccion: field.multipleSelect === 'S' ?
                          (Array.isArray(field.seleccion) ? field.seleccion : []) :
                          (field.seleccion || []),
                multipleSelect: field.multipleSelect !== undefined && field.multipleSelect === "S" ? "true" : "false"
            });
          }
        }
      }

      return fields;
    }

    onOptionSelect(fieldKey: string, optionKey: string, selected: boolean) {
      const selectedOptions = this.config[fieldKey] || [];

      if (selected) {
        // Agrega la opción seleccionada si no está en el array
        if (!selectedOptions.includes(optionKey)) {
          selectedOptions.push(optionKey);
        }
      } else {
        // Remueve la opción si se deselecciona
        const index = selectedOptions.indexOf(optionKey);
        if (index > -1) {
          selectedOptions.splice(index, 1);
        }
      }
    }


    capitalizeFirstLetter(string: string): string {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    async ionViewDidLoad() {
      this.dataInicial()
    }

   async dataInicial() {
      let companiasId = await this.storage.get('companiasId')
      this.servicioPush.buscarParametrosGeneralesOtrosDatos(companiasId)
      .subscribe(async (data)=>{
        let params = JSON.parse(data['_body'])
        this.config = params.data[0][0].datosGenerales

        this.cargarConfiguracion();
      },(error)=>{
        console.log(error)
      })

    }

    cargarConfiguracion() {
      let data = JSON.parse(this.config)
      this.config = data
      this.fields = this.mapFields(data);
    }
    async guardarConfig(config:any) {
      let companiasId = await this.storage.get('companiasId')
      this.servicioPush.actualizarParametrosGeneralesOtrosDatos(companiasId,config)
      .subscribe(async (data)=>{
        this.mensajeToast('Registro guardado con exito')
        let buscarParametrosGeneralesStore: any = await this.utilsRedux.buscarParametrosGeneralesStore()
        this.utilsRedux.buscarParametrosGeneralesRedux(buscarParametrosGeneralesStore.parametrosGenerales[0].companiasId, buscarParametrosGeneralesStore.parametrosGenerales[0].usuariosId)
      },(error)=>{
        console.log(error)
      })
    }

    onSelectChange(field) {
      console.log('Seleccionado:', field);
      this.actualizarCampo(field.key, this.config[field.key].seleccion,this.config);
    }

    ngOnInit() {
      this.fields = [
        {"sobreGiroEnLosProductos":{"opciones":[{"No":"N"},{"Si":"S"}],"seleccion":"N"}}
        ]
      }


    actualizarCampo(key: string, event: any,config:any) {
      const fieldConfig = this.config[key];
      if (!fieldConfig) {
        console.error('Campo no encontrado en config');
        return;
      }
      const seleccionArray = event;

      if (fieldConfig.opciones && Array.isArray(fieldConfig.opciones)) {
        fieldConfig.seleccion = seleccionArray.filter(val =>
          fieldConfig.opciones.some(option => option.key === val)
        );

            // Ahora actualizamos config con las nuevas selecciones
    const configField = config[key];
    if (configField && configField.opciones) {
      configField.opciones.forEach(option => {
        if (fieldConfig.seleccion.includes(option.key)) {
          // Si la opción está seleccionada, la marcamos como 'S'
          option.value.forEach(v => v.visualiza = 'S');
        } else {
          // Si no está seleccionada, la marcamos como 'N'
          option.value.forEach(v => v.visualiza = 'N');
        }
      });
    }
      } else {
        console.error('Configuración de campo inválida para actualizar');
      }
    }

}

class valores{
  public nombre:string;
  public valor:string;
}
class notificaciones{
  public nombre:string;
  public valor:string;
}
class lotesenproductos {
  public nombre:string;
  public valor:string;
}

class manejaImpresoraPorDefecto {
  public nombre:string;
  public valor:number;
}
class Impresoratipobluetooth {
  public nombre:string;
  public valor:string;
}

class ManejarodigoDeBarras{
  public nombre:string;
  public valor:string;
}

class ImprimeLasComandas{
  public nombre:string;
  public valor:string;
}
class deseaImprimirEnElCierre {
  public nombre:string;
  public valor:string;
}



// WEBPACK FOOTER //
// ./src/pages/parametros-generales/parametros-generales.ts